import api from "@/api/api";

export const getUsageDashboardFilters = (orgId) => {
  return api.get(`/organization/${orgId}/usage-dashboard/filters`);
};

export const getUsageDashboardSummary = ({
  orgId,
  courseId,
  instructorId,
  dateFrom,
  dateTo,
} = {}) => {
  return api.get(`/organization/${orgId}/usage-dashboard/summary`, {
    params: { courseId, instructorId, dateFrom, dateTo },
  });
};

export const getUsageDashboardChart = ({
  orgId,
  courseId,
  instructorId,
  dateFrom,
  dateTo,
  period,
  metric,
  groupBy,
} = {}) => {
  return api.get(`/organization/${orgId}/usage-dashboard/chart`, {
    params: {
      courseId,
      instructorId,
      dateFrom,
      dateTo,
      period,
      metric,
      groupBy,
    },
  });
};

export const getUsageDashboardCourses = ({
  orgId,
  courseId,
  instructorId,
  dateFrom,
  dateTo,
  search,
  sortBy,
  sortDir,
  page,
  limit,
} = {}) => {
  return api.get(`/organization/${orgId}/usage-dashboard/courses`, {
    params: {
      courseId,
      instructorId,
      dateFrom,
      dateTo,
      search,
      sortBy,
      sortDir,
      page,
      limit,
    },
  });
};

export const exportUsageDashboardCourses = ({
  orgId,
  courseId,
  instructorId,
  dateFrom,
  dateTo,
  search,
  sortBy,
  sortDir,
} = {}) => {
  return api.get(`/organization/${orgId}/usage-dashboard/courses/export`, {
    params: {
      courseId,
      instructorId,
      dateFrom,
      dateTo,
      search,
      sortBy,
      sortDir,
    },
    responseType: "blob",
  });
};
